import { DroneSource } from './drone.model';

/**
 * Suggested categories for the resource-upload dropdown — not a
 * constraint. `resourceType` is a plain string server-side so "other"
 * can carry a free-form value.
 *
 * Mirrors DRONE_RESOURCE_TYPES in the Hub's data-models/drone-resource.ts.
 */
export const DRONE_RESOURCE_TYPES = [
  'registration',
  'insurance',
  'manual',
  'invoice/proof-of-purchase',
  'maintenance-documentation',
  'other'
];

/**
 * A resource attached to a drone for record-keeping or maintenance
 * history. `droneId` is polymorphic — `droneSource` says whether it
 * points at an ADN drone or an organization-owned one.
 *
 * Mirrors the Hub's DroneResource model / adn_drone_resources table.
 */
export interface DroneResource {
  id: string;
  droneId: string;
  droneSource: DroneSource;
  resourceType: string | null;

  fileName: string;
  fileSize: number | null;
  fileType: string | null;
  fileExtension: string | null;
  caption: string | null;

  s3Key: string;
  cdnUrl: string;

  /** TRUE = ADN staff only. */
  adminOnly: boolean;

  uploadedByProfileId: string | null;
  createdAt: Date | string;
  updatedAt: Date | string;
}
